import _defineProperty from "/home/runner/work/documentation/documentation/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/home/runner/work/documentation/documentation/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["scheme"],
  _excluded2 = ["scheme"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { COMMON, get } from './constants';
import sx from './sx';
import theme from './theme';
var colorStyles = function colorStyles(_ref) {
  var scheme = _ref.scheme,
    props = _objectWithoutProperties(_ref, _excluded);
  return {
    color: scheme === 'gray-light' ? get('colors.gray.9')(props) : scheme === 'gray' ? get('colors.white')(props) : get('colors.gray.6')(props)
  };
};
var bgStyles = function bgStyles(_ref2) {
  var scheme = _ref2.scheme,
    props = _objectWithoutProperties(_ref2, _excluded2);
  return {
    backgroundColor: scheme === 'gray-light' ? get('colors.blackfade15')(props) : scheme === 'gray' ? get('colors.gray.5')(props) : get('colors.counter.bg')(props)
  };
};
var CounterLabel = styled.span.withConfig({
  displayName: "CounterLabel",
  componentId: "sc-1ubx52d-0"
})(["display:inline-block;padding:2px 5px;font-size:", ";font-weight:", ";line-height:", ";border-radius:20px;", ";", ";", ";&:empty{display:none;}", ";"], get('fontSizes.0'), get('fontWeights.bold'), get('lineHeights.condensedUltra'), colorStyles, bgStyles, COMMON, sx);
CounterLabel.defaultProps = {
  theme: theme
};
CounterLabel.propTypes = _objectSpread(_objectSpread({
  children: PropTypes.node,
  scheme: PropTypes.oneOf(['gray', 'gray-light']),
  theme: PropTypes.object
}, COMMON.propTypes), sx.propTypes);
export default CounterLabel;